import { Env } from '@env';
import { GetPushSubscription } from './types';
import { askPushPermissions } from './askPushPermissions';

export const getPushSubscription: GetPushSubscription = async () => {
	await askPushPermissions();

	const pushSubscriptionInstance = await subscribeUserToPush();
	if (!pushSubscriptionInstance) {
		return;
	}

	const pushSubscription = pushSubscriptionInstance.toJSON();

	return { pushSubscription };
};

async function subscribeUserToPush() {
	const registration = await navigator.serviceWorker.getRegistration();
	if (!registration) {
		return;
	}

	const serverKey = Env.REACT_APP_VAPID_KEY;

	await unsubscribeNotMatchingSubscription(registration, serverKey);

	const subscribeOptions = {
		userVisibleOnly: true,
		applicationServerKey: urlBase64ToUint8Array(serverKey),
	};

	return registration.pushManager.subscribe(subscribeOptions);
}

async function unsubscribeNotMatchingSubscription(
	swRegistration: ServiceWorkerRegistration,
	newServerKey: string,
) {
	const currentSubscription = await swRegistration.pushManager.getSubscription();
	if (!currentSubscription) {
		return;
	}

	const currentSubscriptionKey = currentSubscription.toJSON()?.keys?.p256dh;
	if (currentSubscriptionKey === newServerKey) {
		return;
	}

	console.warn('Subscription keys mismatch. Unsubscribing from old subscription');

	return currentSubscription.unsubscribe();
}

function urlBase64ToUint8Array(base64String: string) {
	try {
		const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
		const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);

		for (let i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}

		return outputArray;
	} catch (error) {
		return null;
	}
}
